<template>
  <div class="tabs-group">
    <span
      v-for="{value, label, icon} in statusIconConfigList"
      :label="value"
      :key="value"
    >
      {{ $t(`common.statusMap[${value}]`) }}
      <svg-icon
        :icon-class="icon[iconType]"
        class="icon"
      ></svg-icon>
    </span>
  </div>
</template>

<script>
import { statusIconConfigList } from '@/utils/constants'

export default {

  props: {
    iconType: {
      default: 1,
      type: Number
    }
  },

  data() {
    return {
      tmpValue: '',
      statusIconConfigList
    }
  },

}
</script>

<style lang="scss" scoped>

// $icons: 'wait', 'offline', 'check', 'reject', 'online';
$primary-color: #4071ff;

.icon {
  display: inline-block;
  vertical-align: sub;
  width: 16px;
  height: 16px;

  // @each $icon in $icons {
  //   &.icon-#{$icon} {
  //     background-size: 100% 100%;
  //     background-image: url('~@/assets/icons/#{$icon}.png');
  //   }
  // }
}

.tabs-group {
  color: #667787;
  border-radius: 8px;
  user-select: none;
  border: 1px solid #DCDFE6;
  display: inline-flex;
  background-color: #EBEDF3;
  span {
    padding: 6px 10px;
    line-height: 20px;
    min-width: 90px;
    font-size: 13px;
    cursor: pointer;
  }
}

</style>
